import { render, staticRenderFns } from "./ZoneAssignmentsField.vue?vue&type=template&id=4c6a4af0&scoped=true"
import script from "./ZoneAssignmentsField.vue?vue&type=script&lang=js"
export * from "./ZoneAssignmentsField.vue?vue&type=script&lang=js"
import style0 from "./ZoneAssignmentsField.vue?vue&type=style&index=0&id=4c6a4af0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a4af0",
  null
  
)

export default component.exports